import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import LinkTo from "components/navigation/link/LinkTo";

const SideMenu: React.FC = () => {
  return (
    <SideMenuD>
      <i className="fa fa-bars fa-2x toggle-btn" />

      <Header>
        <LogoLink to="/admin-dashboard">
          <img src="/images/logo.png" alt="logo" />
        </LogoLink>
      </Header>

      <MenuList>
        <LinkTo to="/admin-dashboard/dl-group-li">ODREDNICE</LinkTo>
        <LinkTo to="/admin-dashboard/dl-unit-li">JEDINICE</LinkTo>
        <LinkTo to="/admin-dashboard/photo-ser-li">FOTO SERIJE</LinkTo>
        <LinkTo to="/admin-dashboard/user-li">KORISNICI</LinkTo>

        <ExternalLink to="/hemeroteka" target="_blank">
          HEMEROTEKA
        </ExternalLink>

        <ExternalLink to="/admin-dashboard/l-out">izloguj se</ExternalLink>
      </MenuList>
    </SideMenuD>
  );
};

export default SideMenu;

const SideMenuD = styled.div`
  text-align: left;
  margin-left: 0.2%;
`;

const Header = styled.header`
  display: flex;
  align-items: center;
`;

const LogoLink = styled(RouterLink)`
  margin-left: 7px;
  margin-top: 18px;

  img {
    max-height: 40px;
  }
`;

const MenuList = styled.div`
  display: flex;
  flex-direction: column;
`;

const ExternalLink = styled(LinkTo)`
  margin-top: 2em;
  text-decoration: none;
  color: #000;
`;
